import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode } from "vue"


import MarkdownContent from './MarkdownContent.vue'
import InfoTooltip from './InfoTooltip.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  label: {
    type: String,
  },
  desc: {
    type: String,
  },
  descMarked: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", null, _toDisplayString(__props.label), 1),
    _createVNode(InfoTooltip, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
      content: _withCtx(() => [
        (!__props.descMarked)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(__props.desc), 1)
            ], 64))
          : (_openBlock(), _createBlock(MarkdownContent, {
              key: 1,
              content: __props.desc
            }, null, 8, ["content"]))
      ]),
      _: 1
    }, 16)
  ], 64))
}
}

})